import { Component, Vue, Prop, Inject, Emit } from 'vue-property-decorator';
import { INoviNsFileUploaderGlobals, FileDto } from './INoviNsFileUploaderGlobals';
import EventBus from '../../common/services/EventBus';
import FieldValidationErrors from '../../components/errors/FieldValidationErrors.vue';

declare let noviNs: INoviNsFileUploaderGlobals;

@Component({
    name: 'File',
    components: {
        FieldValidationErrors
    },
    methods: {
        removeFile(e: Event) {
            if (typeof (window as any).removeFile === "function") {
                (window as any).removeFile(e);
            }
        },
    },
})
export default class File extends Vue {
    @Prop({ required: true })
    file!: FileDto;

    @Prop({ required: true })
    customFieldName!: string;

    @Prop({ required: true })
    fileInputName!: string;

    mounted() {
        const input = document.createElement('input');
        input.setAttribute('class', 'hidden');
        input.setAttribute('name', this.fileInputName);
        input.setAttribute('value', `${encodeURIComponent(JSON.stringify(this.file))}`);

        const container = document.getElementById(this.customFieldName);
        if (container) {
            var fileList = container.getElementsByClassName('file-name');
            if (fileList.length) {
                var elementArray = Array.from(fileList);
                var fileElement = elementArray.find((input) => (<HTMLElement>input).innerText == this.decodedFileName)
                if (fileElement) {
                    fileElement.after(input);
                }
            }
        }
    }

    get decodedFileName() {
        return decodeURIComponent(this.file.FileName.replace(/\+/g, ' '));
    }

    get fileValue() {
        return `${encodeURIComponent(JSON.stringify(this.file))}`;
    }

    get downloadUrl() {
        return this.file ? `${noviNs.customFieldFileBaseUrl}/${this.file.FullPath.split('/').pop()}` : "#";
    }
}